import Order from './components/Order';

export default Order;
